import { SelectField } from '@ff-it/form';
import type { ReactElement } from 'react';
import { required } from 'utilities';
import { endHourOptions, startHourOptions } from './const';

export function BandHourField({
  name,
  boundary,
  disabled,
  portal = false,
}: {
  name: string;
  boundary: 'start' | 'end';
  disabled?: boolean;
  portal?: boolean;
}): ReactElement {
  return (
    <SelectField
      name={`${name}.${boundary}_hour`}
      options={boundary === 'start' ? startHourOptions : endHourOptions}
      className="mb-0"
      required
      validate={required}
      simple
      components={{ DropdownIndicator: null }}
      size="sm"
      disabled={disabled}
      menuPortalTarget={portal && typeof document !== 'undefined' ? document.body : undefined}
      menuPosition={portal ? 'fixed' : undefined}
    />
  );
}
